import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

export const getParameterName = async (adcd) => {
  try {
    const res = await axiosInstance.get(API_ROUTES.ParameterName, { params: { adcd } })
    if (res.status === 200) {
      return res.data
    }
    return false
  } catch (error) {
    return false
  }
}
